module.exports = __webpack_public_path__ + "img/eagleMobile.83cc75a.svg";